export default "__VITE_ASSET__BmAGF7uy__"